import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const handleInfo = listeners["handleInfo"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const curItem = vo.row;
    let dealConf = [["icon-message", "查看详情", () => handleInfo(curItem), ""]];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "分组名称",
      prop: "groupName",
    },
    {
      label: "总人数",
      prop: "totalNum",
    },
    {
      label: "已报到",
      prop: "clockNum",
    },
    {
      label: "未报到",
      prop: "notClockNum",
    },
    {
      label: "未报到-待报到",
      prop: "waitClockNum",
    },
    {
      label: "未报到-请假",
      prop: "leaveNum",
    },
    {
      label: "操作",
      width: "100",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
        onSelectionChange={RCSelectionChange}
      />
    </div>
  );
};

export default Table;
